module.exports = __webpack_public_path__ + "img/94846.8b555268.svg";